var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pl-4 pr-2 py-2 my-2",attrs:{"elevation":"0"}},[_c('v-skeleton-loader',{staticClass:"mb-2",attrs:{"type":"text","max-width":"100"}}),_c('v-skeleton-loader',{staticClass:"d-flex",attrs:{"type":"text","max-width":"75"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }